import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { EFItinerary, EFItineraryContent, EFPOI, EFProduct } from '../../../models/experience.model';
import { MapStylesService } from '../../../services/map-styles.service';
import { EFDataService } from '../../../services/ef-data.service';
import { LocalizationService } from '../../../services/localization.service';
import { GoogleMapsService } from '../../../services/google-maps.service';

@Component({
    selector: 'app-ef-product-map',
    templateUrl: './ef-product-map.component.html',
    styleUrls: ['./ef-product-map.component.scss'],
    standalone: false
})
export class EfProductMapComponent implements OnInit, AfterViewInit {

    @Input() productData:EFProduct|EFPOI;
    
    @Input() hideMap:boolean;
    @Input() hideList:boolean;

    @Output() showStop = new EventEmitter<EFItineraryContent>()

    constructor(private mapStylesService:MapStylesService, private efDataService:EFDataService, private localizationService:LocalizationService, private googleMapsService:GoogleMapsService) { }

    ngOnInit(): void {
        this._loadProductItinerary();
    }

    ngAfterViewInit() {
        this.initMap();
    }

    @ViewChild('gmapsElement') gmapsElement: ElementRef;

    map:google.maps.Map = null;
    mapMarker:google.maps.Marker = null;

    initMap() {
        if(this.gmapsElement != null) {
            this.googleMapsService.loadMaps().then(() => {
                this.map = new google.maps.Map(this.gmapsElement.nativeElement, {
                    center: new google.maps.LatLng(0, 0),
                    zoom: 1,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    disableDefaultUI: true,
                    styles: this.mapStylesService.mapStyles.light,
                    gestureHandling: 'cooperative'
                })
                
                if(this.productData.geolocation != null) {
                    let _title = this.getTranslatedValue(this.productData, 'title')
                    if(_title == null) this.getTranslatedValue(this.productData, 'name')
    
                    this.mapMarker = new google.maps.Marker({ 
                        position: new google.maps.LatLng(this.productData.geolocation.coordinates[0], this.productData.geolocation.coordinates[1]),
                        zIndex: 10,
                        title: _title,
                        icon: this.mapStylesService.markerStyles.general.icon
                    });
        
                    this.mapMarker.setMap(this.map)
                }
        
                this.centerMap();
            })
        }
    }

    centerMap() {
        if(this.mapMarker != null) {
            this.map.setCenter(this.mapMarker.getPosition());
            this.map.setZoom(15);
        }
    }

    itineraryData:EFItinerary = null;
    isLoadingItinerary = false;
    isItineraryFullyLoaded = false;

    private _loadProductItinerary() {
        let _itineraryId = this.getItineraryId();

        if(_itineraryId != null) {
            this.isItineraryFullyLoaded = false;

            if(_itineraryId != null) {
                this.isLoadingItinerary = true;
    
                this.efDataService.getItinerary(_itineraryId).subscribe((data) => {
                    this.isLoadingItinerary = false;
    
                    this.itineraryData = data;
        
                    this.isItineraryFullyLoaded = this.itineraryData.isFullyLoaded;
                    this.itineraryData.isFullyLoadedChange.subscribe((val) => {
                        this.isItineraryFullyLoaded = val;
                    })
                })
            }
        }
    }

    getItineraryId() {
        if('getItineraryId' in this.productData) return this.productData.getItineraryId();
    }

    getTranslatedValue(object:any, field:string) { // TODO: questa roba va rimossa in favore delle helper function in EFProduct?
        if(object.translations != null) {
            if('length' in object.translations) {
                for(let _translation of object.translations) {
                    if(_translation.language == this.localizationService.currentLanguage) {
                        if(_translation[field] != null && _translation[field] != '') return _translation[field];
                        else break;
                    }
                }
            }
            else {
                for(let i in object.translations) {
                    if(i == this.localizationService.currentLanguage) {
                        let _translation = object.translations[i];
                        if(_translation[field] != null && _translation[field] != '') return _translation[field];
                        else break;
                    }
                }
            }
        }

        return object[field];
    }

    onShowStop(stop:EFItineraryContent) {
        this.showStop.emit(stop)
    }
}
